/**
 * Niveau d'accès / type d'entité de gestion (valeur runtime).
 *
 * Déplacé depuis l'ancien module de permissions legacy lors de son retrait
 * (chantier #3, session 8). Utilisé comme **valeur**
 * (comparaisons `=== ManagementEntityType.X`) par les gardes/composants.
 *
 * À ne pas confondre avec le **type union** `ManagementEntityType` de
 * `@core/services/administration/management-entity/management-entity.interface`,
 * qui décrit la forme côté API (et utilise `MARKET_LEVEL_ORGANIZATION`).
 */
export enum ManagementEntityType {
  MANAGEMENT_ENTITY = 'MANAGEMENT_ENTITY',
  COMPANY = 'COMPANY',
  POINT_OF_SALE = 'POINT_OF_SALE',
  BROKER_POINT_OF_SALE = 'BROKER_POINT_OF_SALE',
  DIRECT_POINT_OF_SALE = 'DIRECT_POINT_OF_SALE',
  CONTRIBUTOR = 'CONTRIBUTOR',
  SUB_CONTRIBUTOR = 'SUB_CONTRIBUTOR'
}
